RivalIQ.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.Invoice = Backbone.Model.extend({
        parse: function (data) {
            return _.tap(data, function (data) {
                data.id = data.rivalIqInvoiceId;
            });
        }
    });
});
